import type { SubmittedEntry } from '@/api/types/Forms'
import { format } from 'date-fns'

export const formatSubmittedOn = (submitted: string) =>
	format(new Date(submitted), 'MMM d, yyyy')

/**
 * The answers as lines to show.
 *
 * Coerced rather than filtered to strings, so a numeric or boolean answer from an older
 * submission is shown rather than leaving the question looking unanswered.
 */
export const formatAnswers = (answers: SubmittedEntry['answers']): string[] => {
	if (!Array.isArray(answers)) {
		return []
	}
	return answers
		.filter((answer) => answer !== null && answer !== undefined && answer !== '')
		.map((answer) => String(answer))
}

export const formatQuestion = (question: SubmittedEntry['question']) =>
	question?.trim() || 'Unknown question'
